<template lang="pug">
.procurement-select-vendor
  title-bar {{ $t('Brief') }}
  div(style="margin-left: 20px")
    upload-multiple-file(
      :text="$t('附件')"
      :fileName="brief.brief_name"
      :downloadUrl="brief.brief_download_url"
      :files="brief.brief_name_list"
    )
    el-row
      el-col(:span="4") {{ $t('介绍') }}
      el-col(:span="10")
        display-text-container(:text="brief.remark")
    select-end-date(v-if="endDate" v-model="endDate")

  title-bar {{ $t('市场部推荐供应商情况') }}
  div(style="margin-left: 20px")
    marketing-recommend-vendor(
      :scope="market.selected_scope"
      :remark="market.remark"
      :vendor="market.vendor"
    )

  template(v-if="ItRecommendStatus.status !== 0")
    title-bar {{ $t('IT推荐供应商情况') }}
    div(style="margin-left: 20px")
      it-recommend-vendor(
        :remark="it.remark"
        :vendor="it.vendor"
        :isFinalScope="0"
      )

  title-bar {{ $t('下发Brief') }}
  div(v-if="isView" style="margin-left: 20px")
    select-vendor-completed

  div(v-else style="margin-left: 20px")
      select-vendors(
        :categorys="market.selected_scope"
        @changeTable="changeTable"
      )
      el-row
        el-col(
          :span="20"
        )
          footer-button(
            :confirmButton="$t('下一步')"
            @confirm="onConfirm"
            @cancel="cancel"
            :buttonWidth="isZh ? '65px' : '100px'"
          )
</template>
<script>
import TitleBar from '@/components/TitleBar'
import UploadMultipleFile from '@/components/UploadMultipleFile'
import MarketingRecommendVendor from '@/components/MarketingRecommendVendor'
import ItRecommendVendor from '@/components/ITRecommendVendor'
import SelectVendors from './SelectVendors'
import SelectVendorCompleted from './SelectVendorCompleted'
import axios from 'axios'
import FooterButton from '@/components/FooterButton'
import SelectEndDate from '@/components/SelectEndDate'
import { format4backend } from '@/umcc/util'
import DisplayTextContainer from '@/components/DisplayTextContainer'
import db from '@/umcc/db'

export default {
  components: {
    TitleBar,
    UploadMultipleFile,
    MarketingRecommendVendor,
    ItRecommendVendor,
    SelectVendors,
    FooterButton,
    SelectVendorCompleted,
    SelectEndDate,
    DisplayTextContainer
  },
  data () {
    return {
      brief: {},
      selectVendors: {
        vendors: [],
        remark: ''
      },
      market: {},
      it: {
        vendor: [],
        remark: ''
      },
      deliverVendorList: [],
      endDate: null,
      tableData: null,
      ItRecommendStatus: {}
    }
  },
  computed: {
    campaignId () {
      return this.$store.state.campaign.id
    },
    isZh () {
      return db.lang === 'zh'
    }
  },
  mounted () {
    this.fetchBriefInfo()
    this.fetchMarketRecommend()
    this.fetchITRecommend()
    this.getITRecommendStatus()
  },
  methods: {
    async getITRecommendStatus () {
      try {
        this.ItRecommendStatus = await axios.get('/management/subfinal/getItRecommendStatus', {
          params: {
            campaign_id: this.campaignId,
            is_final_scope: 0
          }
        })
      } catch (err) {
        throw new Error(err)
      }
    },
    changeTable (tableData) {
      this.tableData = tableData
    },
    fetchBriefInfo () {
      axios
        .get('management/campaign/getBriefInfo', {
          params: {
            campaign_id: this.$store.state.campaign.id
          }
        })
        .then(res => {
          this.brief = res
          this.endDate = res.deadline
        })
    },
    fetchMarketRecommend () {
      axios
        .get('management/campaign/getMarketRecommend', {
          params: {
            campaign_id: this.$store.state.campaign.id,
            is_final_scope: 0
          }
        })
        .then(res => {
          this.market = res
        })
    },
    fetchITRecommend () {
      axios
        .get('management/campaign/getITRecommend', {
          params: {
            campaign_id: this.$store.state.campaign.id,
            is_final_scope: 0
          }
        })
        .then(res => {
          this.it = res
        })
    },
    onConfirm () {
      if (!this.tableData.some(vendor => {
        if (vendor.user.some(user => user.status === 1)) return true
      })) {
        this.$message.error(this.$t('至少需要下发成功1个'))
        return
      }
      if (this.tableData.filter(vendor => {
        return vendor.recommend_resource !== this.$t('采购部')
      }).some(vendor => {
        if (!vendor.user.some(user => user.status === 1 || user.status === 3)) return true
      })) {
        this.$message.error(this.$t('尚有供应商未下发Brief'))
        return
      }
      if (this.tableData.filter(vendor => {
        return vendor.recommend_resource === this.$t('采购部')
      }).some(vendor => {
        if (!vendor.user.some(user => user.status === 1)) return true
      })) {
        this.$message.error(this.$t('采购部所选供应商，必须为“下发成功”状态'))
        return
      }
      this.$confirm(this.$t('提交后本页面信息将无法编辑，请确定是否提交'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          const params = {
            campaign_id: this.campaignId,
            task_id: this.$store.state.campaign.taskId,
            business_type: this.$store.state.campaign.businessType,
            deadline: this.endDate
          }
          axios.post('/management/campaign/deliverCompleted', format4backend(params)).then(res => {
            this.$message.success(this.$t('成功'))
            this.$router.push('/campaign/process')
          })
        })
    },
    cancel () {
      this.$router.push('/campaign/process')
    }
  }
}
</script>
